@if (extraCount > 0) {
  <h4 class="title">
    <app-app-string key_name="golf.scorecard.playoff"></app-app-string>
  </h4>
}

@if (extraCount > 0) {
  <table class="playoff-table" [class.full]="extraCount >= 8" cellspacing="0" cellpadding="0" style="margin-top: 0.5rem">
    <colgroup>
    <col class="label-col" />
    @for (_ of extraColumns; track _) {
      <col class="hole-col" />
    }
  </colgroup>
  <tbody>
    <tr class="head">
      <th class="label"><app-app-string key_name="golf.hole" /></th>
      @for (i of extraColumns; track i) {
        <th>
          @switch (extraHoleWinner(i)) {
            @case ('eu') {
              <span class="hole-marker eu">{{ i + 1 }}</span>
            }
            @case ('us') {
              <span class="hole-marker us">{{ i + 1 }}</span>
            }
            @case ('team1') {
              <span class="hole-marker team1">{{ i + 1 }}</span>
            }
            @case ('team2') {
              <span class="hole-marker team2">{{ i + 1 }}</span>
            }
            @default {
              <span>{{ i + 1 }}</span>
            }
          }
        </th>
      }
    </tr>
    <tr>
      <th class="label"><app-app-string key_name="golf.par"></app-app-string></th>
      @for (i of extraColumns; track i) {
        <td>{{ extraParAt(i) }}</td>
      }
    </tr>
    @if (!isOverview) {
      @if (isFoursomes) {
        <tr>
          <th class="label">
            <div class="team-label">
              @for (p of teamPlayers('left'); track p) {
                <div>
                  <span class="fit">
                    {{ shortName(p) }}
                  </span>
                </div>
              }
            </div>
          </th>
          @for (i of extraColumns; track i) {
            <td>
              <span class="score" [ngClass]="mergeClasses(getTeamExtraCellClasses('left', i))">
                {{ teamExtraScoreAt('left', i) }}
              </span>
            </td>
          }
        </tr>
      } @else {
        @for (lp of left; track lp) {
          <tr>
            <th class="label">
              <span class="fit">
                {{ shortName(lp.player) }}
              </span>
            </th>
            @for (i of extraColumns; track i) {
              <td>
                <span class="score" [ngClass]="mergeClasses(getExtraCellClasses('left', lp, i))">
                  {{ extraScoreAt(lp, i) }}
                </span>
              </td>
            }
          </tr>
        }
      }
    }
    <tr class="score-row">
      <th class="label"><app-app-string key_name="golf.scorecard.score"></app-app-string></th>
      @for (i of extraColumns; track i) {
        <td>
          <span
            class="score-box"
            [class.eu]="extraLeaderColor(i) === 'eu'"
            [class.us]="extraLeaderColor(i) === 'us'"
            [class.team1]="extraLeaderColor(i) === 'team1'"
            [class.team2]="extraLeaderColor(i) === 'team2'"
            >
            {{ extraScoreLabel(i) }}
          </span>
        </td>
      }
    </tr>
    @if (!isOverview) {
      @if (isFoursomes) {
        <tr>
          <th class="label">
            <div class="team-label">
              @for (p of teamPlayers('right'); track p) {
                <div>
                  <span class="fit">
                    {{ shortName(p) }}
                  </span>
                </div>
              }
            </div>
          </th>
          @for (i of extraColumns; track i) {
            <td>
              <span class="score" [ngClass]="mergeClasses(getTeamExtraCellClasses('right', i))">
                {{ teamExtraScoreAt('right', i) }}
              </span>
            </td>
          }
        </tr>
      } @else {
        @for (rp of right; track rp) {
          <tr>
            <th class="label">
              <span class="fit">
                {{ shortName(rp.player) }}
              </span>
            </th>
            @for (i of extraColumns; track i) {
              <td>
                <span class="score" [ngClass]="mergeClasses(getExtraCellClasses('right', rp, i))">
                  {{ extraScoreAt(rp, i) }}
                </span>
              </td>
            }
          </tr>
        }
      }
    }
  </tbody>
</table>
}
